module.exports = __webpack_public_path__ + "img/8597635.png";